import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import MPWAPI from 'API/MPWApi';
import { Filter, Main } from 'Containers';
import { createToast, toastType } from 'Common/ToastHelper';
import { TitledCard } from 'Components/';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';
import { setNotificationDialog } from 'Components/dialogs/state/actions';

import { UnmatchedTable } from './components/UnmatchedTable';
import { MatchModal } from './components/MatchModal';

class DCUnmatchedUtility extends Component {
  state = {
    unmatched: [],
    matchModalProps: undefined,
    unmatchedPages: -1,
  };

  getMainProps = () => {
    const { fetching } = this.props;
    return {
      toolbox: {
        saveButtonProps: {
          content: 'Save',
          loading: fetching,
        },
        shown: false,
      },
    };
  };

  getUnmatched = async (pageIndex, pageSize, sortOptions, filterOptions) => {
    this.setState({ loading: true });

    try {
      const body = {
        PageNumber: pageIndex,
        PageSize: pageSize,
        SortColumn: sortOptions,
        Filter: filterOptions,
      };
      const response = await MPWAPI.postGenericInsertUpdate(
        'DCUnmatched',
        body
      );
      const meta = response.data.Meta;
      this.setState({
        unmatched: response.data.Data,
        unmatchedPages: meta.Pages,
      });
    } catch (e) {
      createToast(
        toastType.error,
        'Error',
        'There was a problem, please try again.'
      );
    }

    this.setState({ loading: false });
  };

  debouncedGetUnmatched = _.debounce(this.getUnmatched, 250);

  getPossibleMatches = async (id) => {
    const response = await MPWAPI.getGeneric(
      `dcUnmatched/getPossibleMatches?unmatchedId=${id}`
    );

    return response.data.Data;
  };

  handleRowSelection = async (rowInfo) => {
    this.setState({
      matchModalProps: {
        loading: true,
        unmatched: rowInfo,
        possibleMatches: [],
      },
    });

    try {
      const data = await this.getPossibleMatches(rowInfo.Id);

      this.setState({
        matchModalProps: {
          loading: false,
          unmatched: rowInfo,
          possibleMatches: data,
        },
      });
    } catch (e) {
      this.resetMatchModal();
      createToast(
        toastType.error,
        'Error',
        'There was a problem, please try again.'
      );
    }
  };

  resetMatchModal = () => {
    this.setState({ matchModalProps: undefined });
  };

  handleMatchConfirmed = async (matchId) => {
    const { matchModalProps } = this.state;
    const unmatchedId = matchModalProps.unmatched.Id;
    this.setState({
      matchModalProps: {
        ...matchModalProps,
        loading: true,
      },
    });

    try {
      const response = await MPWAPI.postGenericInsertUpdate(
        `dcUnmatched/writeMatch`,
        {
          unmatchedId,
          matchId,
        }
      );

      this.setState({
        unmatched: this.state.unmatched.filter((i) => i.Id !== unmatchedId),
      });
      this.resetMatchModal();
      createToast(toastType.success, 'Success', response.data.Data);
    } catch (e) {
      createToast(
        toastType.error,
        'Error',
        'There was a problem, please try again.'
      );
      this.setState({
        matchModalProps: {
          ...matchModalProps,
          loading: false,
        },
      });
    }
  };

  deleteUnmatched = async () => {
    try {
      const { matchModalProps } = this.state;
      const unmatchedId = matchModalProps.unmatched.Id;
      this.setState({
        matchModalProps: {
          ...matchModalProps,
          loading: true,
        },
      });

      await MPWAPI.postGenericInsertUpdate(`DCUnmatched/DeleteUnmatched`, {
        unmatchedId,
      });

      this.setState({
        unmatched: this.state.unmatched.filter((i) => i.Id !== unmatchedId),
      });
      createToast(toastType.success, 'Success', 'DC Unmatched Deleted');
    } catch (ex) {
      createToast(
        toastType.error,
        'Error',
        'There was a problem, please try again.'
      );
    } finally {
      this.resetMatchModal();
    }
  };

  handleDeclinedBenefits = () => {
    const { setNotificationDialog } = this.props;

    setNotificationDialog({
      ...NOTIFICATION_DIALOG_MESSAGES.DC_UNMATCHED_DECLINED_BENEFITS,
      functionsToRunOnOk: [this.deleteUnmatched],
    });
  };

  render() {
    const { loading, unmatched, matchModalProps, unmatchedPages } = this.state;

    return (
      <Fragment>
        <Filter title="Unmatched DC Imported Students" />
        <Main {...this.getMainProps()}>
          <TitledCard title={'Select a row to match'}>
            <UnmatchedTable
              loading={loading}
              unmatched={unmatched}
              onRowSelect={this.handleRowSelection}
              getUnmatched={this.debouncedGetUnmatched}
              pages={unmatchedPages}
            />
            {matchModalProps && (
              <MatchModal
                {...matchModalProps}
                closeModal={this.resetMatchModal}
                onMatchConfirmed={this.handleMatchConfirmed}
                onDeclinedBenefits={this.handleDeclinedBenefits}
              />
            )}
          </TitledCard>
        </Main>
      </Fragment>
    );
  }
}

const mapDispatch = { setNotificationDialog };

DCUnmatchedUtility = connect(null, mapDispatch)(DCUnmatchedUtility);

export { DCUnmatchedUtility };



// WEBPACK FOOTER //
// ./src/pages/dcunmatchedutility/DCUnmatchedUtility.js